import { usdBbdFromLandedUsd } from '../lib/usdBbdDisplay';

/**
 * Landed price for Barbados shoppers: USD primary, BBD at official 2:1 peg.
 */
export default function DualLandedPrice({
  amount,
  size = 'md',
  showLabels = true,
  className = '',
  usdClassName = '',
  bbdClassName = 'text-slate-500',
  testId,
}) {
  const { usd, bbd } = usdBbdFromLandedUsd(amount);
  if (usd <= 0) return null;

  const sizeClasses = {
    sm: { usd: 'text-sm font-semibold', bbd: 'text-xs' },
    md: { usd: 'text-base font-bold', bbd: 'text-sm' },
    lg: { usd: 'text-2xl font-bold', bbd: 'text-sm font-medium' },
  };
  const sizes = sizeClasses[size] || sizeClasses.md;

  return (
    <span className={className} data-testid={testId}>
      <span className={`${sizes.usd} ${usdClassName}`.trim()}>
        ${usd.toFixed(2)}
        {showLabels ? ' USD' : ''}
      </span>
      <span className={`${sizes.bbd} ${bbdClassName} ml-1.5`}>
        | BBD ${bbd.toFixed(2)}
      </span>
    </span>
  );
}
